import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGridApiRef, GridActionsCellItem } from "@mui/x-data-grid-pro";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Snackbar,
  Alert,
  FormLabel,
  Typography,
  Button as SaveButton
} from "@mui/material";
import { Delete } from "@mui/icons-material";

import { Container } from "./styles";

import {
  createLeaseEventComment,
  deleteLeaseEventComment,
  getLeaseEventComments,
  resetLeaseEventComments,
  updateLeaseEventComment,
} from "redux/actions/leaseEventActions";
import colors from "styles/colors";
import moment from "moment";
import { Edit, Close } from "@mui/icons-material";
import { EditableDataGridPro, EditableCell } from "components/EditableDataGrid";
import TextEditor from "components/TextEditor";

import { RichTextReadOnly } from "mui-tiptap";
import StarterKit from "@tiptap/starter-kit";

import { EditUser, formatHtmlToCSV, sanitizeHtml, formatDisplayName } from "shared/utils";
import { getClientsUsers } from "redux/actions/clientActions";
import { ComboBox } from "components/ComboBox/Combobox";
import EditIcon from "@mui/icons-material/Edit";
import "./styles.css";

const CommentsModal = (props) => {
  const { open, onClose = () => {}, onSave = () => {}, id, data } = props;

  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.currentUser.details);
  const comments = useSelector((state) => state.leaseEvents.comments);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ text: "", severity: "success" });
  const apiRef = useGridApiRef();
  const dateFormat = "DD MMM YYYY hh:mm A";
  const selectedClientId = useSelector(
    (state) => state.clients.selectedClientId
  );

  useEffect(() => {
    dispatch(getClientsUsers(selectedClientId));
  }, [selectedClientId]);

  const clientUsers = useSelector((state) => state.clients.clientUsers);
  // Mirrors the mapping used by the Transaction/Pre-Transaction Comments
  // mention list: de-dupe by lower-cased email and exclude the current user.
  const userOptions = (() => {
    const seenEmails = new Set();
    return clientUsers
      .filter(
        (x) =>
          x.userEmailAddress?.toLowerCase() !==
          userDetails?.userEmailAddress?.toLowerCase()
      )
      .filter((x) => {
        const email = x.userEmailAddress?.toLowerCase();
        if (!email || seenEmails.has(email)) return false;
        seenEmails.add(email);
        return true;
      })
      .map((x) => x.userEmailAddress);
  })();
  // const taggedUsers = comments[0]?.taggedUsers || [];
  const [selectedUsers, setNewTagUser] = useState([]);
  const [editUsersList, setEditUsersList] = useState([]);
  const [error, setError] = useState(true);
  const [isEditClicked, setEditClick] = useState(false);
  const [currentcellComment, setCurrentCellComment] = useState(undefined);
  const [currentcellTagUsers, setCurrentTagUsers] = useState(undefined);
  const [currentRowId, setCurrentRow] = useState(0);

  const SetTagUser = (event) => {
    const {
      target: { value },
    } = event;

    setNewTagUser(value);
  };

  const editUser = EditUser();
  console.log("");

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(getLeaseEventComments(id)).finally(() => setLoading(false));
    }
    return () => {
      dispatch(resetLeaseEventComments());
    };
  }, [id, dispatch]);

  const handleEditUsersList = (userList) => {
    setCurrentTagUsers(userList);
    setEditUsersList(userList);
  };

  const columns = [
    {
      field: "commentId",
      headerName: "CommentId",
    },    
    {
      editable: true,
      field: "comment",
      valueFormatter:({ value }) => formatHtmlToCSV(value),
      cellClassName: (params) => 
        params.id === currentRowId && isEditClicked ? 'editatble-cell' : 'read-only-cell',
      renderHeader: () => (
        <>
          <div>Comment</div>
        </>
      ),
      width: 450,
      flex: 3,
      renderCell: (params) => {
        return (
          <div className="cell-content">
            <RichTextReadOnly
              content={params.value}
              extensions={[StarterKit]}
            />
          </div>
        );
      },
      renderEditCell: (params) => {
        return isEditClicked && params.row.commentId === currentRowId ? (
          <TextEditor
            id={params.row.commentId}
            value={params.value}
            onUpdate={(comment) => {
              apiRef.current.setEditCellValue({
                id: params.id,
                field: params.field,
                value: comment,
              });
              setCurrentCellComment(comment);
              handleBlur(comment);
            }}
          />
        ) : (
          <div className="cell-content">
            <RichTextReadOnly
              content={params.value}
              extensions={[StarterKit]}
            />
          </div>
        );
               
      },
    },
    {
      editable: true,
      field: "taggedUsers",
      minWidth: 200,
      cellClassName: (params) => 
      params.id === currentRowId && isEditClicked ? 'editatble-cell' : 'read-only-cell',
      renderHeader: () => (
        <>
          <div>Mentions</div>
        </>
      ),
      renderCell: (params) => params.row.taggedUsers.join("; "),
      renderEditCell: (params) => {
        if (
          params.row.commentBy.toLowerCase() !==
          userDetails.userEmailAddress.toLowerCase() 
        )
          return params.row.taggedUsers.join("; ");

        return (
          isEditClicked  && (params.row.commentId === currentRowId)? 
          (<EditTaggedUser
            initialValue={params.row.taggedUsers ?? []}
            options={userOptions}
            onChildStateChange={handleEditUsersList}
            id={params.id}
            field={params.field}
            apiRef={apiRef}
          ></EditTaggedUser>)
          :(params.row.taggedUsers.join("; "))
        );
      },
    },
    {
      field: "commentBy",
      headerName: "Comment By",
      minWidth: 200,      
      cellClassName: "read-only-cell",
    },
    {
      field: "commentedDate",
      headerName: "Date & Time",
      minWidth: 120,
        renderCell: (params) =>         
          moment.utc(params.value).local().format(dateFormat),
    },
    {
      field: "actions",
      type: "actions",
      width: 120,
      flex: 1,
      headerName: "Actions",
      headerClassName: "grid-app-header action-icons",
      getActions: (params) => [
        <GridActionsCellItem
          icon={
              <EditIcon />
          }
          disabled={params.row.commentBy !== userDetails.userEmailAddress || isEditClicked}
          label="Edit Transaction"
          onClick={() => onEdit(params.row)}
        />,
        <GridActionsCellItem
          disabled={params.row.commentBy !== userDetails.userEmailAddress || isEditClicked}
          icon={<Delete />}
          label="Delete Comment"
          onClick={() => onDelete(params.row)}
        />,
      ],
    },
  ];

  const onDelete = (params) => {
    setLoading(true);
    dispatch(
      deleteLeaseEventComment({
        commentId: params.commentId,
        userEmail: userDetails.userEmailAddress,
        clientId : selectedClientId,
      })
    ).finally(() => {
      setLoading(false);
      onSave();
    });
  };

  const onEdit = (params) => {
    setCurrentRow(params.commentId);
    apiRef.current.setRowSelectionModel([params.commentId]);
    apiRef.current.startRowEditMode({ id: params.commentId, fieldToFocus :"comment"});
    apiRef.current.startRowEditMode({ id: params.commentId, fieldToFocus :"taggedUsers"});
    setEditClick(true);
  };

  const addComment = () => {
    if (!invalidComment(newComment)) {
      const taggedUsers = selectedUsers;
      const data = {
        leaseEventId: id,
        comment: sanitizeHtml(newComment),
        createdBy: userDetails.userEmailAddress,
        taggedUsers: taggedUsers,
        clientId : selectedClientId
      };
      setLoading(true);
      dispatch(createLeaseEventComment(data))
        .then(() => {
          setNewComment("");
          setNewTagUser([]);
          if (id) {
            setLoading(true);
            setNewTagUser([]);
          }
        })
        .finally(() => {
          setLoading(false);
          onSave();
        });
      setError(true);
    }
  };

  const saveRowChange = () => {
    const commentsToUpdate = [];
    const tableCommentValue = apiRef.current.getCellValue(
      currentRowId,
      "comment"
    );
    const tableTaggedUsersValue = apiRef.current.getCellValue(
      currentRowId,
      "taggedUsers"
    );
    if (
      (currentcellComment && currentcellComment !== tableCommentValue) ||
      (currentcellTagUsers && currentcellTagUsers !== tableTaggedUsersValue)
    ) {
      commentsToUpdate.push({
        id: currentRowId,
        leaseEventId: id,
        modifiedBy: userDetails.userEmailAddress,
        comment: sanitizeHtml(
          currentcellComment !== undefined
            ? currentcellComment
            : tableCommentValue
        ),
        taggedUsers:
          currentcellTagUsers !== undefined
            ? currentcellTagUsers
            : tableTaggedUsersValue,
      });
    }

    const rowMode = apiRef.current.getRowMode(currentRowId);
    if (rowMode === "edit") {
      apiRef.current.stopRowEditMode({ id: currentRowId });
    }

    setTimeout(() => {
      apiRef.current.stopCellEditMode({
        id: currentRowId,
        field: "comment",
      });
      apiRef.current.stopCellEditMode({
        id: currentRowId,
        field: "taggedUsers",
      });
      apiRef.current.resetRowHeights();
      apiRef.current.forceUpdate();
     
    }, 100);
    setEditClick(false);
    if (commentsToUpdate.length) {
      return dispatch(updateLeaseEventComment(commentsToUpdate, selectedClientId))
        .then(() => {
          setAlert({ text: "Comments updated", severity: "success" });
          onSave();
          setCurrentCellComment(undefined);
          setCurrentTagUsers(undefined);
        })
        .catch(() => {
          setAlert({
            text: "Error updating comments. Try again",
            severity: "error",
          });
          setCurrentCellComment(undefined);
          setCurrentTagUsers(undefined);
        });
    } else {
      return Promise.resolve(
        setAlert({ text: "No changes to save", severity: "info" })
      );
    }
  };

  const cancelRowChange = () => {
    var currentComment = comments.filter((x) => x.commentId === currentRowId);
    if (currentComment.length > 0) {
      apiRef.current.setEditCellValue({
        id: currentRowId,
        field: "comment",
        value: currentComment[0].comment,
      });
      apiRef.current.setEditCellValue({
        id: currentRowId,
        field: "taggedUsers",
        value: currentComment[0].taggedUsers,
      });
      
      setTimeout(() => {
        apiRef.current.stopCellEditMode({
          id: currentRowId,
          field: "comment",
        });
        apiRef.current.stopCellEditMode({
          id: currentRowId,
          field: "taggedUsers",
        });
        apiRef.current.resetRowHeights();
        apiRef.current.forceUpdate();      
      }, 100);

      setEditClick(false);
      setCurrentCellComment(undefined);
      setCurrentTagUsers(undefined);
    }
  };

  const setTagUsers = (tagUsers) => {
    setNewTagUser(tagUsers);
    if (isEditClicked) {
      cancelRowChange();
    }
  };

  const saveAllChanges = () => {
    //go through each comment and check if the value has been edited in the table
    const commentsToUpdate = [];
    comments.forEach((c) => {
      const tableCommentValue = apiRef.current.getCellValue(
        c.commentId,
        "comment"
      );
      const tableTaggedUsersValue = apiRef.current.getCellValue(
        c.commentId,
        "taggedUsers"
      );
      //if(!invalidComment(c.comment)){
      if (
        c.comment !== tableCommentValue ||
        c.taggedUsers !== tableTaggedUsersValue
      ) {
        commentsToUpdate.push({
          id: c.commentId,
          leaseEventId: c.leaseEventId,
          modifiedBy: userDetails.userEmailAddress,
          comment: sanitizeHtml(tableCommentValue),
          taggedUsers: tableTaggedUsersValue,
        });
      }
      //}

      setError(true);
    });

    // if(!error){
    if (commentsToUpdate.length) {
      return dispatch(updateLeaseEventComment(commentsToUpdate, selectedClientId))
        .then(() => {
          setAlert({ text: "Comments updated", severity: "success" });
          onSave();
        })
        .catch(() =>
          setAlert({
            text: "Error updating comments. Try again",
            severity: "error",
          })
        );
    } else
      return Promise.resolve(
        setAlert({ text: "No changes to save", severity: "info" })
      );
    //}
  };

  const handleBlur = (comment) => {
    invalidComment(comment);
  };

  const handleUpdate = (comment) => {
    invalidComment(comment);
  };

  const invalidComment = (comment) => {
    console.log("I m in");
    if (
      comment.trim() === "" ||
      comment === "<p><br></p>" ||
      comment === "<p></p>"
    ) {
      setError(true);
      return true;
    } else {
      setError(false);
      return false;
    }
  };

  return (
    <>
      <Snackbar
        open={!!alert.text}
        autoHideDuration={5000}
        onClose={() => setAlert({ text: "", severity: "success" })}
      >
        <Alert
          onClose={() => setAlert({ text: "", severity: "success" })}
          severity={alert.severity}
        >
          {alert.text}
        </Alert>
      </Snackbar>
      <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ display: "flex" }}>
          <Box flexGrow={1}>Lease Event Comments</Box>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Container>
            <EditableDataGridPro
              apiRef={apiRef}
              columns={columns}
              rows={comments}
              loading={loading}
              keepFocusOnEnter
              getRowId={(row) => row.commentId}
              save={saveAllChanges}
              canEdit={editUser}
              userEmailAddress={userDetails.userEmailAddress}
              enableSaveAll={false}
              isEditClicked={isEditClicked}
              saveRowChange={saveRowChange}
              cancelRowChange={cancelRowChange}
            />
          </Container>
          <Box>
            <Typography variant="h6" className="comment-label">
              Create a comment
            </Typography>
          </Box>
          {editUser && (
            <>
              <br></br>
              <LabelAndField
                label="Mentions"
                field={
                  <ComboBox
                    options={userOptions}
                    selectedValue={selectedUsers}
                    setValue={setTagUsers}
                    styleList={{ position: "absolute", zIndex: 999 }}
                    getOptionLabel={formatDisplayName}
                    renderOption={renderMentionOption}
                  />
                }
              />
              <Box display="flex" mt={1}>
                <TextEditor
                  label="Enter Comment"
                  sx={{ flexGrow: 1, mr: 2 }}
                  value={newComment}
                  onBlur={(newComment) => {
                    handleBlur(newComment);
                  }}
                  onUpdate={(newComment) => {
                    handleUpdate(newComment);
                    setNewComment(newComment);
                    if (isEditClicked) {
                      cancelRowChange();
                    }
                  }}
                />
              </Box>
              <Box>
                {error && (
                  <span style={{ color: "red" }}>
                    Comment field cannot be empty
                  </span>
                )}
              </Box>
              <Box mt={1} mb={5}>
                <SaveButton
                  disabled={error}
                  size="medium"
                  variant="contained"
                  className="create-comment-save"
                  onClick={addComment}
                >
                  Save
                </SaveButton>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
const renderMentionOption = (email) => (
  <Box display="flex" flexDirection="column" flexGrow={1} minWidth={0}>
    <Box component="span" sx={{ fontWeight: 600, fontSize: "14px" }}>
      {formatDisplayName(email)}
    </Box>
    <Box component="span" sx={{ fontSize: "12px", color: "#6B7280" }}>
      {email}
    </Box>
  </Box>
);

const LabelAndField = (props) => {
  const { label, field, required } = props;
  return (
    <Box display="flex"  sx={{ position: "relative",border : "1px groove" }}>
      <FormLabel
        style={{
          flexGrow: 1,
          maxWidth: "30%",
          alignSelf: "center",
          fontWeight: 400,
          fontSize:16,
          marginLeft: 10,
          fontFamily:"Source Sans Pro",
        }}
        required={required}
      >
        {label}
      </FormLabel>
      <div style={{ flexGrow: 1, maxWidth: "70%" }}>{field}</div>
    </Box>
  );
};

const GridDropDown = (props) => {
  const { field } = props;
  return (
    <Box sx={{ width: "100%" }}>
      <div style={{ flexGrow: 1 }}>{field}</div>
    </Box>
  );
};

const EditTaggedUser = (props) => {
  const { initialValue, options, onChildStateChange, id, field, apiRef} =
    props;
  const [users, setUsers] = useState(initialValue || []);
  const handleOnChangeTaggerUser = (value) => {
    setUsers(value);
    onChildStateChange(value);
    apiRef.current.setEditCellValue({
      id: id,
      field: field,
      value: value,
    });
  };
  return (
    <GridDropDown
      sx={{ width: "100%" }}
      field={
        <ComboBox
          options={options}
          selectedValue={users || initialValue}
          onChangeTaggerUser={handleOnChangeTaggerUser}
          setValue={setUsers}
          getOptionLabel={formatDisplayName}
          renderOption={renderMentionOption}
        />
      }
    />
  );
};
export default CommentsModal;
